var _excluded = ["cleanable", "disabled", "error", "full", "helper", "label", "maxLength", "readOnly", "style", "value", "onChange", "onClean", "hideMaxLength", "rightIcon"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { func, string, bool, number, shape, oneOfType, node } from 'prop-types';
import { Close } from '@gympass/yoga-icons';
import { theme } from '../../Theme';
import Field from './Field';
import Helper from './Helper';
import Fieldset from './Fieldset';
import Legend from './Legend';
import Label from './Label';
var Control = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  width: ", ";\n"])), function (_ref) {
  var full = _ref.full;
  return full ? '100%' : css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n          ", "px\n        "])), theme.components.input.width);
});
var IconWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var disabled = _ref2.disabled,
      _ref2$hasIconRight = _ref2.hasIconRight,
      hasIconRight = _ref2$hasIconRight === void 0 ? false : _ref2$hasIconRight,
      _ref2$theme$yoga = _ref2.theme.yoga,
      colors = _ref2$theme$yoga.colors,
      spacing = _ref2$theme$yoga.spacing,
      input = _ref2$theme$yoga.components.input;
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    top: 0;\n    right: ", "px;\n\n    padding-right: ", "px;\n    padding-left: ", "px;\n\n    height: ", "px;\n    cursor: pointer;\n\n    outline: none;\n\n    &:hover svg,\n    &:focus svg {\n      fill: ", ";\n    }\n\n    svg {\n      height: ", "px;\n      width: 20px;\n      fill: ", ";\n    }\n\n    ", "\n  "])), hasIconRight ? spacing.large : 0, spacing.small, spacing.xxsmall, input.height, input.font.color.focus, input.height, input.font.color["default"], disabled ? "\n      cursor: not-allowed;\n      pointer-events: none;\n      svg {\n        fill: " + colors.text.disabled + ";\n      }\n    " : '');
});
var Input = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var cleanable = _ref3.cleanable,
      disabled = _ref3.disabled,
      error = _ref3.error,
      full = _ref3.full,
      helper = _ref3.helper,
      label = _ref3.label,
      maxLength = _ref3.maxLength,
      readOnly = _ref3.readOnly,
      style = _ref3.style,
      value = _ref3.value,
      onChange = _ref3.onChange,
      onClean = _ref3.onClean,
      hideMaxLength = _ref3.hideMaxLength,
      rightIcon = _ref3.rightIcon,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded);

  var inputRef = ref || useRef(null);

  var cleanField = function cleanField(e) {
    if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClean('');
      inputRef.current.focus();
    }
  };

  return /*#__PURE__*/React.createElement(Control, {
    full: full
  }, /*#__PURE__*/React.createElement(Fieldset, {
    disabled: disabled,
    error: error,
    full: full,
    label: label,
    style: style,
    value: value
  }, /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    label: label,
    cleanable: cleanable,
    disabled: disabled,
    error: error,
    full: full,
    readOnly: readOnly,
    maxLength: maxLength,
    ref: inputRef,
    value: value,
    onChange: onChange
  })), /*#__PURE__*/React.createElement(Label, {
    error: error,
    disabled: disabled
  }, label), label && /*#__PURE__*/React.createElement(Legend, null, label), cleanable && !readOnly && value && /*#__PURE__*/React.createElement(IconWrapper, {
    tabIndex: 0,
    disabled: disabled,
    onClick: cleanField,
    onKeyDown: cleanField,
    width: 20,
    height: 20,
    role: "button",
    hasIconRight: !!rightIcon
  }, /*#__PURE__*/React.createElement(Close, {
    "aria-label": "Clear"
  })), !!rightIcon && !readOnly && /*#__PURE__*/React.createElement(IconWrapper, {
    tabIndex: 0,
    disabled: disabled,
    width: 20,
    height: 20,
    role: "button"
  }, rightIcon)), (helper || maxLength || error) && /*#__PURE__*/React.createElement(Helper, {
    error: error,
    helper: helper,
    maxLength: maxLength,
    length: value.length,
    disabled: disabled,
    hideMaxLength: hideMaxLength
  }));
});
Input.propTypes = {
  className: string,

  /** display a close icon to clean the field */
  cleanable: bool,
  disabled: bool,
  error: string,
  full: bool,

  /** a helper text to be displayed below field */
  helper: string,
  label: string,

  /** maximum length (number of characters) of value */
  maxLength: number,
  readOnly: bool,
  style: shape({}),
  value: oneOfType([string, number]),
  onChange: func,

  /** callback invoked when close icon is clicked, it returns a empty string to update your state */
  onClean: func,

  /** when max length helper is unnecessary to appear */
  hideMaxLength: bool,
  placeholder: string,
  rightIcon: node
};
Input.defaultProps = {
  className: undefined,
  cleanable: true,
  disabled: false,
  error: undefined,
  full: false,
  helper: undefined,
  label: 'Label',
  maxLength: undefined,
  readOnly: false,
  style: undefined,
  value: '',
  onChange: function onChange() {},
  onClean: function onClean() {},
  hideMaxLength: false,
  placeholder: undefined,
  rightIcon: undefined
};
export default Input;